// Define trigger product IDs
// Define trigger product ID groups
var triggerProductIDsGroupA = [
    430991568949, 6818104049749, 6818104279125, 6818104475733,
    6818104967253, 6818105622613, 6818105983061, 6818106114133,
    6818106277973, 6818106343509, 6818106474581, 6818106638421,
    6818106966101, 6986970857557, 6818104213589, 1430991568949
];

var triggerProductIDsGroupB = [6985019719765];
var triggerProductIDsGroupC = [6985014378581];


// Define special variant ID
var specialVariantID = '40738170798165';
var specialVariantID2 = '40743125942357';

if ( typeof CartForm !== 'function' ) {
  
    class CartForm extends HTMLElement {

        constructor(){
            super();
            this.ajaxifyCartItems();

          // Custom Code - Blender Fix
                 this.initiatePollingOnCartPage();
        }

// START: Custom Code - Blender Fix
      initiatePollingOnCartPage() {
          if (this.isOnCartPage()) {
              this.pollCartUntilReady();
              this.bindCartUpdateEvents(); // Bind event listeners
          }
      }
      
      pollCartUntilReady() {
          let lastItemCount = 0; // Store the last number of items to detect changes
      
          const poll = async () => {
              if (!this.isOnCartPage()) {
                  console.log('Navigated away from the cart page, stopping polling...');
                  return;
              }
      
              const cartItems = await this.fetchCartItems();
      
              // Check if the number of items changed or any other significant change
              if (cartItems.length !== lastItemCount) {
                  lastItemCount = cartItems.length; // Update the last item count
                  const is3rdPartyDone = this.check3rdPartyCartChanges(cartItems);
      
                  if (is3rdPartyDone) {
                      console.log('3rd party app changes detected, updating cart...');
                      this.checkAndUpdateSpecialVariant();
                       this.refreshAjaxCartSubtotal();
                  } else {
                      // Use a longer delay or different logic to continue polling
                      setTimeout(poll, 600000); // 5000(5 seconds) 600000(10 mins) Reduce frequency when waiting for changes
                  }
              } else {
                  // No change in item count, check less frequently
                  setTimeout(poll, 1200000); // / 10000(10 seconds) 1200000(20 mins)
              }
          };
      
          poll(); // Start the polling process
      }

      refreshAjaxCartSubtotal() {
            // fetch and reinject the AjaxCartSubtotal
            fetch('?section_id=helper-cart')
                .then(response => response.text())
                .then(text => {
                    const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
                    const ajaxCartSubtotal = sectionInnerHTML.getElementById('AjaxCartSubtotal');
                    document.getElementById('AjaxCartSubtotal').innerHTML = ajaxCartSubtotal.innerHTML;
                });
        }
      
          bindCartUpdateEvents() {
              const addToCartButtons = document.querySelectorAll('button.add-to-cart');
              addToCartButtons.forEach(button => {
                  button.addEventListener('click', () => {
                      console.log('Item added to cart, re-checking...');
                      this.pollCartUntilReady(); // Trigger an immediate check when an item is added
                  });
              });
          }
      
          isOnCartPage() {
              // Check if the current URL is the cart page
              return window.location.href.includes('/cart');
          }
      
      async fetchCartItems() {
          try {
              const response = await fetch('/cart.js');
              if (!response.ok) throw new Error('Network response was not ok.');
              const cartData = await response.json();
              return cartData.items;
          } catch (error) {
              console.error('Could not fetch cart items:', error);
              return [];
          }
      }
      
      
          check3rdPartyCartChanges(cartItems) {
              // Placeholder for actual logic to determine if 3rd party changes are done
              return true;
          }
// END: Custom Code - Blender Fix

      
        ajaxifyCartItems(){

            this.form = this.querySelector('form');

            this.querySelectorAll('[data-js-cart-item]').forEach(function(item){

                var remove = item.querySelector('.remove');
                if ( remove ) {
                    remove.dataset.href = remove.getAttribute('href');
                    remove.setAttribute('href', '');
                    remove.addEventListener('click', function(e){
                        e.preventDefault();
                        this.updateCartQty(item, 0);
                    }.bind(this))
                }

                var qty = item.querySelector('.qty');
                if ( qty ) {
                    qty.addEventListener('input', debounce(function(e){
                        e.preventDefault();
                        e.target.blur();
                        this.updateCartQty(item, parseInt(qty.value));
                    }.bind(this), 500));
                    qty.addEventListener('click', function(e){
                        e.target.select();
                    })
                }

            }.bind(this))

        }

        updateCartQty(item, newQty){
            const checkoutBtnArea = document.querySelector('#AjaxCartSubtotal');

            if (checkoutBtnArea) {
              checkoutBtnArea.classList.add('chkbtn-disabled');
              

            }

            var alert = null;

            this.form.classList.add('processing');
            if ( this.querySelector('.alert') ) {
                this.querySelector('.alert').remove();
            }

            var body = JSON.stringify({
                id: item.dataset.id,
                quantity: newQty
            });

            fetch(KROWN.settings.routes.cart_change_url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
                    body
                })
                .then(function(response){ return response.json() })
                .then(function(response){
                    if ( response.status == 422 ) {
                        // wrong stock logic alert
                        alert = document.createElement('span');
                        alert.classList.add('alert', 'alert--error');
                        if ( typeof response.description === 'string' ) {
                            alert.innerHTML = response.description;
                        } else {
                            alert.innerHTML = response.message;
                        }
                    }
                    return fetch('?section_id=helper-cart');
                })
                .then(function(response){ return response.text() })
                .then(function(text){

                    var sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
                    var cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                    var cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

                    var cartItems = document.getElementById('AjaxCartForm');
                    cartItems.innerHTML = cartFormInnerHTML;
                    cartItems.ajaxifyCartItems();

                    document.querySelectorAll('[data-header-cart-count]').forEach(function(elm){
                        elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
                    });
                    document.querySelectorAll('[data-header-cart-total').forEach(function(elm){
                        elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
                    });

                    if ( alert !== null ) {
                        this.form.prepend(alert);
                    } 

                    document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
                            
                    var event = new Event('cart-updated');
                    this.dispatchEvent(event);
// CUSTOM CODE
          this.checkAndUpdateSpecialVariant();
                }.bind(this))
                .catch(function(e){
                    console.log(e);
                    var alert = document.createElement('span');
                    alert.classList.add('alert', 'alert--error');
                    alert.textContent = KROWN.settings.locales.cart_general_error;
                    this.form.prepend(alert);
                }.bind(this))
                .finally(function(){
                   
                    this.form.classList.remove('processing');
                    if (checkoutBtnArea) {

                        setTimeout(() => {
                          checkoutBtnArea.classList.remove('chkbtn-disabled');
                        }, 2000);
                    }
// START: Custom Code - Cart Planta Promo Message
    var event = new Event('cart-updated');
    document.dispatchEvent(event);
// END: Custom Code - Cart Planta Promo Message
                  
                }.bind(this));

        }

checkTriggerProductsInCart(triggerProductIDs) {
    var triggerProductTotalQty = 0;
    var cartItems = this.querySelectorAll('[data-js-cart-item]');
    for (var item of cartItems) {
        var productId = parseInt(item.getAttribute('data-product-id'));
        var quantity = parseInt(item.querySelector('.qty').value);
        console.log("Checking product ID:", productId, "Quantity:", quantity); // Additional logging
        if (triggerProductIDs.includes(productId)) {
            triggerProductTotalQty += quantity;
        }
    }
    console.log("Total Quantity for ", triggerProductIDs, ": ", triggerProductTotalQty);
    return triggerProductTotalQty;
}



isSpecialVariantInCart() {
    var cartItems = this.querySelectorAll('[data-js-cart-item]');
    var specialVariantCount = 0;

    for (var item of cartItems) {
        var variantId = item.getAttribute('data-id');
        var numericVariantId = variantId.split(':')[0]; // Extract the numeric part
        var quantity = parseInt(item.querySelector('.qty').value);

        if (numericVariantId && numericVariantId.toString() === specialVariantID.toString()) {
            specialVariantCount += quantity;
        }
    }

    return specialVariantCount;
}

// Implement the isSpecialVariantInCart2 method similar to isSpecialVariantInCart, but for specialVariantID2
isSpecialVariantInCart2() {
    var cartItems = this.querySelectorAll('[data-js-cart-item]');
    var specialVariantCount2 = 0;

    for (var item of cartItems) {
        var variantId = item.getAttribute('data-id');
        var numericVariantId = variantId.split(':')[0]; // Extract the numeric part
        var quantity = parseInt(item.querySelector('.qty').value);

        if (numericVariantId && numericVariantId.toString() === specialVariantID2.toString()) {
            specialVariantCount2 += quantity;
        }
    }

    return specialVariantCount2;
}
      
checkAndUpdateSpecialVariant() {
    setTimeout(() => {
    
        var triggerProductQtyGroupA = this.checkTriggerProductsInCart(triggerProductIDsGroupA);
        var triggerProductQtyGroupB = this.checkTriggerProductsInCart(triggerProductIDsGroupB);
        var triggerProductQtyGroupC = this.checkTriggerProductsInCart(triggerProductIDsGroupC);
        var specialVariantCount = this.isSpecialVariantInCart();      
        var specialVariantCount2 = this.isSpecialVariantInCart2(); // Checking for specialVariantID2
  
        console.log("Quantity in Group A: ", triggerProductQtyGroupA);
        console.log("Quantity in Group B: ", triggerProductQtyGroupB);
        console.log("Quantity in Group C: ", triggerProductQtyGroupC);
        console.log("Special Variant Count: ", specialVariantCount);
        console.log("Special Variant 2 Count: ", specialVariantCount2);

        var totalSpecialVariantsNeeded = triggerProductQtyGroupB + triggerProductQtyGroupC;
        if (triggerProductQtyGroupA >= 3) totalSpecialVariantsNeeded += 1;

        var totalSpecialVariantsNeeded2 = triggerProductQtyGroupB + triggerProductQtyGroupC; // Same calculation for specialVariantID2

        console.log("Total Special Variants Needed: ", totalSpecialVariantsNeeded);
        console.log("Total Special Variants 2 Needed: ", totalSpecialVariantsNeeded2);

        if (specialVariantCount < totalSpecialVariantsNeeded) {
            // this.addProductToCart(specialVariantID, totalSpecialVariantsNeeded - specialVariantCount);
        } else if (specialVariantCount > totalSpecialVariantsNeeded) {
            this.updateCartQtyForSpecialVariant(specialVariantID, totalSpecialVariantsNeeded);
        }

        if (specialVariantCount2 < totalSpecialVariantsNeeded2) {
            this.addProductToCart(specialVariantID2, totalSpecialVariantsNeeded2 - specialVariantCount2);
        } else if (specialVariantCount2 > totalSpecialVariantsNeeded2) {
            this.updateCartQtyForSpecialVariant(specialVariantID2, totalSpecialVariantsNeeded2);
        }

    }, 500); // Delay of 500 milliseconds
}

      
updateCartQtyForSpecialVariant(variantID, newQty) {
    var changeCartUrl = '/cart/change.js';
    var bodyData = {
        id: variantID,
        quantity: newQty
    };

    fetch(changeCartUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bodyData)
    })
    .then(function(response){
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(function(data){
        console.log('Special variant quantity updated:', data);
    })
    .catch(function(error){
        console.error('There has been a problem:', error);
    })
    .finally(function(){
        window.refreshCart(); // Refresh the cart in finally block
    });
}


// START: Add Blender To Cart
        addProductToCart(variantID, quantity) {
            var addToCartUrl = '/cart/add.js';
            var bodyData = {
                items: [{ id: variantID, quantity: quantity }]
            };

            fetch(addToCartUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(bodyData)
            })
            .then(function(response){
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(function(data){
                console.log('Product added:', data);
            })
            .catch(function(error){
                console.error('There has been a problem:', error);
            })
            .finally(function(){
                window.refreshCart(); // Refresh the cart in finally block
            });
        }
// END Add Blender To Cart

      
// START: Remove Blender From Cart
        removeProductFromCart(variantID) {
            var changeCartUrl = '/cart/change.js';
            var bodyData = {
                id: variantID,
                quantity: 0
            };

            fetch(changeCartUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(bodyData)
            })
            .then(function(response){
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(function(data){
                console.log('Product removed:', data);
            })
            .catch(function(error){
                console.error('There has been a problem:', error);
            })
            .finally(function(){
                window.refreshCart(); // Refresh the cart in finally block
            });
        }
// END: Remove Blender From Cart



      
    } 

    if ( typeof customElements.get('cart-form') == 'undefined' ) {
        customElements.define('cart-form', CartForm);
    }
}

if (typeof CartProductQuantity !== 'function') {

    class CartProductQuantity extends HTMLElement {
        constructor() {
            super();
            // Check if elements exist before adding event listeners
            const qtyMinus = this.querySelector('.qty-minus');
            const qtyPlus = this.querySelector('.qty-plus');

            if (qtyMinus) {
                qtyMinus.addEventListener('click', this.changeCartInput.bind(this));
            } else {
                console.error('.qty-minus not found in CartProductQuantity');
            }

            if (qtyPlus) {
                qtyPlus.addEventListener('click', this.changeCartInput.bind(this));
            } else {
                console.error('.qty-plus not found in CartProductQuantity');
            }
        }

        changeCartInput() {
           
            var self = this;
            setTimeout(function() {
                const qtyElement = self.querySelector('.qty');
                if (qtyElement) {
                    document.getElementById('AjaxCartForm').updateCartQty(self.closest('[data-js-cart-item]'), parseInt(qtyElement.value));
                } else {
                    console.error('.qty element not found in changeCartInput');
                }
            }, 50);
        }
    }

    if (typeof customElements.get('cart-product-quantity') == 'undefined') {
        customElements.define('cart-product-quantity', CartProductQuantity);
    }
}

if ( ! window.refreshCart ) {

    window.refreshCart = function() {
        
        fetch('?section_id=helper-cart')
            .then(function(response){ return response.text() })
            .then(function(text){

                var sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
                var cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                var cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

                var cartItems = document.getElementById('AjaxCartForm');
                cartItems.innerHTML = cartFormInnerHTML;
                cartItems.ajaxifyCartItems();

                document.querySelectorAll('[data-header-cart-count]').forEach(function(elm){
                    elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
                });
                document.querySelectorAll('[data-header-cart-total').forEach(function(elm){
                    elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
                });

                document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
                if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
                    document.querySelector('[data-js-site-cart-sidebar]').show();
                }

                if ( document.querySelector('cart-recommendations') ) {
                    document.querySelector('cart-recommendations').innerHTML = '';
                    document.querySelector('cart-recommendations').generateRecommendations();
                }

            });

    }
}

// Function to trigger when the cart updates
function onCartUpdate() {
    var cartFormElement = document.getElementById('AjaxCartForm');
    if (cartFormElement) {
        cartFormElement.checkAndUpdateSpecialVariant();
    }
}

// Select the cart element
var cartElement = document.getElementById('AjaxCartForm');

// Create a callback function to execute when mutations are observed
var callback = function(mutationsList, observer) {
    for (var mutation of mutationsList) {
        if (mutation.type === 'childList') {
            // Call the function when the cart updates
            onCartUpdate();
        }
    }
};

// Check if the cart element exists
if (cartElement) {
    // Create an observer instance linked to the callback function
    var observer = new MutationObserver(callback);

    // Start observing the cart element for configured mutations
    observer.observe(cartElement, { childList: true, subtree: true });
} else {
    console.error('Cart element not found');
}


